<div class="permission-editor-container">
  @if (selectedUser && permissions) {
    <div class="editor-header">
      <h2>Editando Permisos de:</h2>
      <span class="user-name">{{ selectedUser.name }} {{ selectedUser.firstSurname }}</span>
      <span class="user-email">{{ selectedUser.email }}</span>
    </div>

    <div class="permissions-list">

      <div class="permission-item" (click)="toggleAccordion('general')" [class.active]="activeAccordion === 'general'">
        <div class="item-header">
          <div class="item-info">
            <h4>Permiso General</h4>
            <p>Controla el nivel de acceso principal del usuario.</p>
          </div>
          <div class="item-toggle-icon"><img src="assets/static/icons/arrow.svg" alt="Toggle" [class.rotated]="activeAccordion === 'general'"/></div>
        </div>
        @if (activeAccordion === 'general') {
          <div class="item-controls" (click)="$event.stopPropagation()">
            <div class="radio-group">
              <label [class.selected]="permissions.general.level === 'VER'"><input type="radio" value="VER" [(ngModel)]="permissions.general.level"><span>Ver</span></label>
              <label [class.selected]="permissions.general.level === 'SUBIR'"><input type="radio" value="SUBIR" [(ngModel)]="permissions.general.level"><span>Subir</span></label>
              <label [class.selected]="permissions.general.level === 'EDITAR'"><input type="radio" value="EDITAR" [(ngModel)]="permissions.general.level"><span>Editar</span></label>
              @if (canAssignAdmin) {
                <label [class.selected]="permissions.general.level === 'ADMIN'"><input type="radio" value="ADMIN" [(ngModel)]="permissions.general.level"><span>Admin</span></label>
              }
            </div>
          </div>
        }
      </div>

      <div class="permission-item" (click)="toggleAccordion('functions')" [class.active]="activeAccordion === 'functions'">
        <div class="item-header">
          <div class="item-info">
            <h4>Funcionalidades</h4>
            <p>Acceso a las secciones principales de la aplicación.</p>
          </div>
          <div class="item-toggle-icon"><img src="assets/static/icons/arrow.svg" alt="Toggle" [class.rotated]="activeAccordion === 'functions'"/></div>
        </div>
        @if (activeAccordion === 'functions') {
          <div class="item-controls" (click)="$event.stopPropagation()">
            <div class="checkbox-group">
              <label [class.selected]="permissions.functions.analysis"><input type="checkbox" [(ngModel)]="permissions.functions.analysis"><span>Análisis</span></label>
              <label [class.selected]="permissions.functions.performance"><input type="checkbox" [(ngModel)]="permissions.functions.performance"><span>Rendimiento</span></label>
              <label [class.selected]="permissions.functions.health"><input type="checkbox" [(ngModel)]="permissions.functions.health"><span>Salud</span></label>
            </div>
          </div>
        }
      </div>

      <div class="permission-item" (click)="toggleAccordion('gender')" [class.active]="activeAccordion === 'gender'">
        <div class="item-header">
          <div class="item-info">
            <h4>Género</h4>
            <p>Visibilidad sobre datos por género.</p>
          </div>
          <div class="item-toggle-icon"><img src="assets/static/icons/arrow.svg" alt="Toggle" [class.rotated]="activeAccordion === 'gender'"/></div>
        </div>
        @if (activeAccordion === 'gender') {
          <div class="item-controls" (click)="$event.stopPropagation()">
            <div class="radio-group">
              <label [class.selected]="permissions.gender.id === '1'"><input type="radio" value="1" [(ngModel)]="permissions.gender.id"><span>Masculino</span></label>
              <label [class.selected]="permissions.gender.id === '2'"><input type="radio" value="2" [(ngModel)]="permissions.gender.id"><span>Femenino</span></label>
              <label [class.selected]="permissions.gender.id === '3'"><input type="radio" value="4" [(ngModel)]="permissions.gender.id"><span>Todos</span></label>
            </div>
          </div>
        }
      </div>

      <div class="permission-item" (click)="toggleAccordion('categories')" [class.active]="activeAccordion === 'categories'">
        <div class="item-header">
          <div class="item-info">
            <h4>Categorías</h4>
            <p>Acceso jerárquico a categorías.</p>
          </div>
          <div class="item-toggle-icon"><img src="assets/static/icons/arrow.svg" alt="Toggle" [class.rotated]="activeAccordion === 'categories'"/></div>
        </div>
        @if (activeAccordion === 'categories') {
          <div class="item-controls scrollable" (click)="$event.stopPropagation()">
            <div class="checkbox-group">
              @for (cat of permissions.categories; track cat.id) {
                <label [class.selected]="cat.has_access"><input type="checkbox" [(ngModel)]="cat.has_access"><span>{{ cat.name }}</span></label>
              }
            </div>
          </div>
        }
      </div>

      <div class="permission-item" (click)="toggleAccordion('competitions')" [class.active]="activeAccordion === 'competitions'">
        <div class="item-header">
          <div class="item-info">
            <h4>Competiciones</h4>
            <p>Selecciona las competiciones a las que tiene acceso.</p>
          </div>
          <div class="item-toggle-icon"><img src="assets/static/icons/arrow.svg" alt="Toggle" [class.rotated]="activeAccordion === 'competitions'"/></div>
        </div>
        @if (activeAccordion === 'competitions') {
          <div class="item-controls scrollable" (click)="$event.stopPropagation()">
            <div class="checkbox-group">
              @for (comp of permissions.competitions; track comp.id) {
                <label [class.selected]="comp.has_access"><input type="checkbox" [(ngModel)]="comp.has_access"><span>{{ comp.name }}</span></label>
              }
            </div>
          </div>
        }
      </div>

    </div>

    <div class="actions">
      <button class="btn-danger" (click)="onDeleteUser()" [disabled]="isDeleting()">
        @if (isDeleting()) { Eliminando... } @else { Eliminar Usuario }
      </button>

      <button class="primary" (click)="onSaveChanges()" [disabled]="isDeleting()">
        @if (selectedUser.status == 'activo') {Actualizar Permisos}
        @else {Habilitar Permisos}
      </button>
    </div>

  } @else {
    <div class="no-user-selected">
      <p>Selecciona un usuario de la lista para ver o editar sus permisos.</p>
    </div>
  }
</div>
